<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <div class="container title-container">
        <div class="row">
          <span class="title-box">
            <h1 class="title">CONSTRUCTION</h1>
          </span>
          <span class="message-background">
            <h2 class="message">各種プラントの組立、解体、保管を中心に、特殊シールドの据付や工場の移転まで。</h2>
          </span>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-1.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                工事案内
              </div>
              各種プラントの
              組立、解体、保管をはじめ、
              豊富な工事実績があります。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">特に、骨材ヤード、上屋工法はすばやい設置、廃材発生無し、レイアウト自在の特徴を生かし、これまでに300カ所以上の舗装現場で採用されました。（特許取得済）</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-2.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                プラント工事実績
              </div>
              全国の高速道路310工区以上の
              現場で、プラントの工事を
              行ってまいりました。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="small-text">当社では１９７１年に成田空港道路建設の際に大型アスファルトプラントの建設を行い、以来２０１６年度までの約４５年間に、高速道路では３１０工区以上の現場で、アスファルトプラント、ソイルプラントの組立及び解体を行ってきました。
                    近年のプラント工事およびプラントリース実績

                    【高速道路】
                    ・北海道横断自動車道余市小樽舗装工事(2017-2018)
                    ・新東名高速道路伊勢原、伊勢原北IC-秦野IC間、海老名IC-秦野北間の各舗装工事(2020-2022)
                    ・新名神高速道路 高槻、箕面、川西、神戸、菰野の各舗装工事(2016-2019)
                    ・東京外環自動車道 松戸、高谷の各舗装工事(2016-2018)
                    ・中部横断自動車道 六郷-増穂、新清水-富沢の各舗装工事(2016-2019)
                    ・首都圏中央連絡自動車道（圏央道） 稲敷、成田、常総、桶川、幸手、坂東西、坂東の各舗装工事(2013-2016)
                    ・東北中央自動車道 南陽、上山の各舗装工事(2017-2019)
                    ・館山自動道 富津舗装工事（2017-2018）
                    ・東関東自動車道 鉾田舗装工事（2016～2017）
                    ・常磐自動車道 楢葉-富岡間舗装工事(2019-2020)、いわき、双葉、広野、山元IC-岩沼IC間の各工事(2020-2021)
                    ・上信越自動車道 上越舗装工事(2017～2018)
                    ・東海北陸自動車道 郡上、高山の各舗装工事(2017～2019)
                    ・東海環状自動車道 関広見舗装工事(2019-2020)
                    ・南阪奈道路 竹内舗装工事(2019-2020)
                    ・近畿自動車道紀勢線湯浅御坊道路 日高川、広川の各舗装工事（2020-2021)
                    ・舞鶴若狭自動車道 福知山舗装工事(2020-2021)

                    【空港】
                    ・羽田空港 国際線滑走路建設工事(2009-2010)
                    ・岩国空港 路盤工事（2008、2012、2013）
                    ・静岡空港 舗装工事（2007～2008）

                    【ソイルプラントリース】
                    ・圏央道 海老名舗装工事(2012-2013)
                    ・東九州自動車道 苅田舗装工事(2013-2014)、行橋舗装工事(2014)
                    ・東海北陸自動車道 郡上舗装工事(2017～2019)
                    ・常磐自動車道 いわき舗装工事（2020-2021）</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container contact-container">
      <div class="row office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>本社工事部</span>
          〒339-0011 埼玉県さいたま市岩槻区長宮77
          T:048-799-1211｜F:048-799-0623
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>機材センター</span>
          〒330-0011 埼玉県さいたま市岩槻区長宮102 他
          T:048-799-0019 プラント保管14,000m2
        </div>
      </div>
    </div>
  </div>
  <script type="application/ld+json">
    {
      "@context": "http://schema.org/",
      "@type": "JobPosting",
      "title": "プラント工事リーダー・スタッフ",
      "description": "<p>現場での機械組立て・解体の現場監督・スタッフを募集！</p>\n<p>主に実施していただくのはアスファルトプラントの組立・解体となり、4〜8名のチームで、およそ2週間かけて取り組んでいく作業です。<br>\n工事の最初から最後まで携わるため、組立・解体後に味わう達成感はひとしお。<br>\n「仕事をやりきった」という実感が、大きなやりがいに繋がります。<br>\n勤務は8時〜17時で、残業が発生することはほとんどなし。<br>\nゆとりある環境のもと、のびのびとご活躍ください</p>",
      "datePosted": "2020-12-01",
      "validThrough": "2021-06-01",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "東栄運輸株式会社",
        "sameAs": "https://www.toei.myweb.co.jp/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "埼玉県",
          "addressLocality": "さいたま市",
          "streetAddress": "岩槻区長宮77",
          "postalCode": "339-0011",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "value": "260000",
          "minValue": "260000",
          "maxValue": "350000",
          "unitText": "MONTH"
        }
      }
    }
  </script>
</div>
</template>

<script>
export default {
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'CONSTRUCTION',
      message: '各種プラントの組立、解体、保管を中心に、特殊シールドの据付や工場の移転まで。'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/construction.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
}
.table th {
  font-size: 24px;
  color: #000000;
  vertical-align: middle;
}
.type-table {
  font-size: 24px;
}
.type-table td{
  font-size: 24px;
  text-align: end;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    font-size: 20px;
    padding-left: 0;
    padding-right: 0;
  }
  .type-table th {
    font-size: 20px;
  }
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 16px;
}
.small-text {
  font-size: 12px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.caption {
  position: absolute;
  top: 0%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #7E7474;
  display: flex;
  padding: 25px 20px 25px 20px;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 20px;
  margin-bottom: 11px;
  margin-left: 0px;
  margin-right: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
  text-align: left;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.office-box {
  padding: 0px 10% 0px 12%;
}
@media screen and (max-width: 480px) {
  .office-box {
    padding: 0px 0px 0px 0px;
  }
  .contact {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 21px;
  }
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.message-background {
  background: #333333 0% 0% no-repeat padding-box;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 14.5px;
  padding-right: 14.5px;
  position: absolute;
  bottom: 40px;
  margin: 20px;
}
.title {
  top: 106px;
  left: 64px;
  font-size: 76px;
  font-weight: 700;
  letter-spacing: 0;
  border-bottom: solid;
  color: #0A0909;
  opacity: 1;
  position: absolute;
  top: 45px;
  left: 20px;
}
@media screen and (max-width:600px) {
  .message-background {
    background: #333333 0% 0% no-repeat padding-box;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 14.5px;
    padding-right: 14.5px;
    position: absolute;
    bottom: 40px;
    margin: 20px;
  }
  .title {
    top: 106px;
    left: 64px;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0;
    border-bottom: solid;
    color: #0A0909;
    opacity: 1;
    position: absolute;
    top: 45px;
    left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Construction.vue